export default __webpack_public_path__ + "../staticImages/sprite-vinos-store-ch-2x.png";